<template>
<div id="LeaseContract">
  <div :class="`loader${loaderClass}`" v-show="loading"></div>
  <div id="page-content-wrapper" class="admin-content-area" >
    <template v-if="cantAccessPage === true">
      <div class="page-name">
        <div class="page-title">Contract Revenue Report</div>
        <div class="web-action-btn btn-groups text-right">
              <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                  <i class="fp-export"></i> Export
              </a>
        </div>
        <div class="web-action-btn btn-groups text-right">
          <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportEnrichReports()">
            <i class="fp-export"></i> Compare
          </a>
        </div>
      </div>
      <div class="container-fluid">
        <div class="admin-page-content contact-list">
          <data-table-filter-config :moduleName="'contractRevenue'" ref="filterComponent" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
          <div class="data-table bg-white overflow-hidden">
            <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
            <section class="bg-white data-table">
              <custom-pagination
                  :page-changed="onPageChange"
                  :per-page-changed="onPerPageChange" :moduleName="'contractRevenue'" :position="'top'">
              </custom-pagination>

              <vue-good-table
                  mode="remote"
                  ref="contractRevenueReportTable"
                  title="Contract Revenue"
                  @on-page-change="onPageChange"
                  @on-sort-change="onSortChange"
                  @on-column-filter="onColumnFilter"
                  @on-per-page-change="onPerPageChange"
                  :totalRows="totalRecords"
                  :columns="userColumns"
                  :rows="rows"
                  :paginationOptions="{
                      enabled: false,
                      position: 'both',
                      perPage: perPage,
                      dropdownAllowAll: false,
                      setCurrentPage:listCurrentPage,
                      perPageDropdown:dropDownPerPage,
                  }"
                  :search-options="{
                  enabled: false,
                  }"

                  >
              </vue-good-table>
              <custom-pagination
                  :page-changed="onPageChange"
                  :per-page-changed="onPerPageChange">
              </custom-pagination>
            </section>
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="cantAccessPage === false">
      <div class="container-fluid">
          <div class="bg-white text-center">
              <h1>
                  Oops!</h1>
              <h2>
                  403 </h2>
              <div class="error-details">
                  Sorry!, You don't have permission to access this page.
              </div>
          </div>
      </div>
    </template>
    <template v-else>
      <loading-content></loading-content>
    </template>
    <app-footer></app-footer>
  </div>
</div>
</template>
<script>
import Vue from "vue";
 import {commonMixins} from '../../mixins/commonMixins';
 import {dataTableMixins} from '../../mixins/dataTableMixins';
export default {
  name: "LeaseContract",
  metaInfo(){
       return {
         title : 'Contract Revenue Report | FleetPro Application'
       }
    },
  mixins: [commonMixins,dataTableMixins],
  data: () => ({
    cantAccessPage:"",
    loading: false,
    action: 'list',
    permissions:[],
    rows: [],
    totalRecords: 0,
    userColumns:[],
    columns:[
      {
          label: 'Unit Number',
          field: 'unit_no',
          fpFieldType:"text",
          hidden:false,
          filterable: true,
      },
      {
          label: 'Agreement Header Type',
          field: 'agreement_type',
          fpFieldType:"option",
          sortable: false,
          filterable: true,
           filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "All", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              filterDropdownItems: ['LC','RC'],
              trigger: "enter" //only trigger on enter not on keyup
          }
      },
      {
          label: 'Agreement Number',
          field: 'agreement_no',
          filterable: true,
          fpFieldType:"text",
      },
      {
          label: 'Contract Base Amount',
          field: 'base_amount',
          filterable: true,
          type:'number',
          fpFieldType:"integer",
      },
      {
          label: 'Contract Billed Amount',
          field: 'billed_amount',
          filterable: true,
          type:'number',
          fpFieldType:"integer",
      },
      {
          label: 'Contract Billed Rate',
          field: 'billed_rate',
          filterable: true,
          type:'number',
          fpFieldType:"integer",
      },
      {
          label: 'Contract Billed Tax',
          field: 'billed_tax',
          filterable: true,
          type:'number',
          fpFieldType:"integer",
      },
      {
          label: 'Contract Billing Date',
          field: 'billing_date',
          filterable: true,
          fpFieldType:"custom_date",
      },
      {
          label: 'Contract Type',
          field: 'conType',
          filterable: true,
          fpFieldType:"option",
      },
      {
          label: 'Section / Charge',
          field: 'section',
          filterable: true,
          fpFieldType:"text",
      },
      {
          label: 'Invoice Number',
          field: 'invoice_number',
          filterable: true,
          fpFieldType:"text",
      },
      {
          label: 'Invoice Date',
          field: 'invoice_date',
          filterable: true,
          fpFieldType:"custom_date",
      },
      {
          label: 'Metric Type',
          field: 'uom',
          filterable: true,
          fpFieldType:"text",
      },
      {
          label: 'Customer Number',
          field: 'customer_code',
          fpFieldType:"text",
          filterable: true,
      },
      {
          label: 'Customer Name',
          field: 'customer_name',
          fpFieldType:"text",
          filterable: true,
      },

      {
          label: 'Contract Facility',
          field: 'location',
          fpFieldType:"option",
          filterable: true
      },
       {
          label: 'Current Pool',
          field: 'pool',
          hidden:false,
          filterable: true,
          fpFieldType:"option",
      },
      {
          label: 'Equip Status',
          field: 'status',
          fpFieldType:"option",
          filterable: true,
      },
      {
          label: 'Equip Owner',
          field: 'ownership',
          fpFieldType:"option",
          filterable: true,
      },
      {
          label: 'Equip Type',
          field: 'asset_type',
          hidden:false,
          filterable: true,
          fpFieldType:"option",
      },
      {
          label: 'Equipment Type Description',
          field: 'equip_type_desc',
          hidden:false,
          filterable: true,
          fpFieldType:"text",
      },
      {
          label: 'Model Code',
          field: 'model_code',
          hidden:false,
          filterable: true,
          fpFieldType:"text",
      },
      {
          label: 'Serial Number',
          field: 'vin',
          hidden:false,
          filterable: true,
          fpFieldType:"text",
      },
      {
          label: 'Unit Description',
          field: 'vehicle_name',
          hidden:false,
          filterable: true,
          fpFieldType:"text",
      },
      {
          label: 'Tax Override',
          field: 'tax_override',
          hidden:false,
          filterable: false,
          fpFieldType:"text",
          sortable:false,
      },

      {
          label: 'Customer Class Code',
          field: 'customer_class',
          hidden:false,
          fpFieldType:"option",
          filterable: true,
      },
      {
          label: 'Customer Type Code',
          field: 'customer_type',
          fpFieldType:"option",
          hidden:false,
          filterable: true,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "All", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              filterDropdownItems: ['LTD', 'LLC','LP','General Partnership','Municipality/ Government', 'Internal Account'],
              trigger: "enter" //only trigger on enter not on keyup
          }
      },
      {
          label: 'Current Facility',
          field: 'assigned_facility',
          fpFieldType:"option",
          filterable: true,
      },
      {
          label: 'Source Document',
          field: 'source_document',
          fpFieldType:"text",
          filterable: true,
          sortable:true
      },
      {
          label: 'Reading LTD',
          field: 'ltd_reading',
          hidden:false,
          filterable: true,
          type:'number',
          fpFieldType:"integer",
      },
      {
          label: 'Actual/Estimate',
          field: 'is_accurate',
          hidden:false,
          filterable: true,
          fpFieldType:"option",
          sortable:false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "All", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              filterDropdownItems: ['Actual', 'Estimate'],
              trigger: "enter" //only trigger on enter not on keyup
          }
      },
      {
          label: 'Reading Original Out',
          field: 'reading_out',
          hidden:false,
          filterable: false,
          fpFieldType:"integer",
          type:'number',
          sortable:false
      },
      {
          label: 'Reading Billed To Date',
          field: 'reading_in',
          hidden:false,
          filterable: false,
          fpFieldType:"integer",
          type:'number',
          sortable:false
      },
      {
          label: 'Date Billed From',
          field: 'bill_from_date',
          hidden:false,
          filterable: true,
          fpFieldType:"custom_date",
      },
      {
          label: 'Date Billed To',
          field: 'bill_to_date',
          hidden:false,
          filterable: true,
          fpFieldType:"custom_date",
      },
      {
          label: 'Transaction Equipment Pool',
          field: 'trasaction_eq_pool',
          hidden:false,
          filterable: true,
          fpFieldType:"option",
      },
      {
          label: 'Original Rate',
          field: 'rate',
          hidden:false,
          filterable: true,
          fpFieldType:"integer",
          type:'number',
      },

      {
          label: 'Discounted Revenue',
          field: 'discounted_revenue',
          hidden:false,
          fpFieldType:"integer",
          type:'number',
          filterable: false,
          sortable:false
      },
      {
          label: 'Discount Reason',
          field: 'discount_reason',
          hidden:false,
          fpFieldType:"text",
          filterable: false,
          sortable:false
      },
    ],
    batchProcess:0,
    batchNum:"",
  }),
  watch:{
    permissions: function(permission) {
        var self = this;
        permission.forEach(function (permissions) {
            if(permissions.name == 'contract_revenue_report') {
                self.cantAccessPage = true;
            }
        });
        if(self.cantAccessPage == ''){
            self.cantAccessPage = false;
        }
    },
  },
  mounted: function(){
    var self = this;
    self.getPermissions();
  },
  methods:{
    cancelAll: function (cancelAll) {
      this.$refs.leaseContractReportTable.unselectAllInternal();
    },
    // exportReports: function() {
    //     var self = this;
    //     this.action = "export";
    //     this.loadList();
    // },
    loadList: function(){
      var self = this;
      self.loading = true;
      var date = new Date();
      var offset = date.getTimezoneOffset();

      $.ajax({
        url: process.env.ROOT_API + "/contract-revenue-report/list",
        type: "POST",
        crossDomain: true,
        headers: this.ajxHeaders,
        dataType: "json",
        data: {
          page: self.serverParams.page,
          perPage: self.serverParams.perPage,
          filters: self.serverParams.columnFilters,
          sort: self.serverParams.sort,
          offset: offset,
          action: self.action


        },
        success: function(data) {
          self.loading = false;
          if (data.status == "success") {
             if (self.action == "export" ||  self.action == "export_queue" || self.action == "compare-with-enrich" ||  self.action == "compare-with-enrich_queue") {
                if ( data.code == "201" ) {
                    alert(data.message);
                } else {
                    if ( self.action == "export" || self.action == "compare-with-enrich" ) {

                        self.excel = data.content.web;
                        var save = document.createElement("a");
                        save.href = self.excel;
                        save.download = data.content.web;
                        save.target = "_blank";

                        document.body.appendChild(save);
                        save.click();
                        document.body.removeChild(save);
                    } else {

                        self.batchProcess = 1;
                        self.batchNum = data.content;
                    }
                }

              self.action = "list";
              self.loadList();

            } else {
                if (data.content.row != undefined) {
                  self.rows = data.content.row;
                }

                self.totalRecords = data.content.totalRecords;
            }


          }
        },
        error: function(jqXHR, exception) {
          self.loading = false;
            self.generateStatusCodeMessage(jqXHR,true,'lease-contract-list')
        }
      });


    }

  }

}
</script>



// WEBPACK FOOTER //
// src/components/reports/ContractRevenueReport.vue